import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  Box,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

interface VehiculosTableProps {
  headerBgColor?: string;
  headerTextColor?: string;
  borderColor?: string;
  bodyBgColor?: string;
  bodyTextColor?: string;
  iconDelete?: string;
  iconEdit?: string;
  onDelete?: (index: number) => void;
  onEdit?: (index: number) => void;
  rows?: Array<{
    vehiculo: string;
    cantidad: number;
    monto: string;
    residual: string;
  }>;
  isLoading?: boolean;
}

const getCellHeaderSx = (bg: string, text: string, border: string) => ({
  fontWeight: 600,
  backgroundColor: bg,
  color: text,
  borderBottom: `1px solid ${border}`,
  borderRight: `1px solid ${border}`,
  padding: "6px 8px",
  lineHeight: 1.2,
});

const getCellBodySx = (bg: string, text: string, border: string) => ({
  backgroundColor: bg,
  color: text,
  borderRight: `1px solid ${border}`,
  padding: "6px 8px",
  lineHeight: 1.2,
});

export default function VehiculosTable({
  headerBgColor = "#F7F9FC",
  headerTextColor = "#002652",
  borderColor = "#E0E0E0",
  bodyBgColor = "#FFFFFF",
  bodyTextColor = "#002652",
  iconDelete = "#FF0000",
  iconEdit = "#0000FF",
  onDelete,
  onEdit,
  rows,
  isLoading = false,
}: VehiculosTableProps) {
  return (
    <TableContainer component={Paper} sx={{ borderRadius: 0, boxShadow: "none" }}>
      <Table>
        <TableHead>
          <TableRow>
            {/* Vehículo (sin borde derecho, con borde izquierdo) */}
            <TableCell
              sx={{
                ...getCellHeaderSx(headerBgColor, headerTextColor, borderColor),
                borderRight: `1px solid ${borderColor}`,
                borderLeft: "none",
              }}
            >
              Vehículo
            </TableCell>

            <TableCell sx={getCellHeaderSx(headerBgColor, headerTextColor, borderColor)}>Cantidad</TableCell>

            <TableCell sx={getCellHeaderSx(headerBgColor, headerTextColor, borderColor)}>Monto</TableCell>

            <TableCell sx={getCellHeaderSx(headerBgColor, headerTextColor, borderColor)}>Residual</TableCell>

            {/* Acciones (sin borde derecho) */}
            <TableCell
              sx={{
                ...getCellHeaderSx(headerBgColor, headerTextColor, borderColor),
                borderRight: "none",
              }}
              align="center"
            >
              Acciones
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {(rows ?? []).map((row, index) => (
            <TableRow key={index}>
              {/* Vehículo */}
              <TableCell
                sx={{
                  ...getCellBodySx(bodyBgColor, bodyTextColor, borderColor),
                  borderRight: `1px solid ${borderColor}`,
                  borderLeft: "none",
                }}
              >
                {row.vehiculo}
              </TableCell>

              <TableCell sx={getCellBodySx(bodyBgColor, bodyTextColor, borderColor)}>{row.cantidad}</TableCell>

              <TableCell sx={getCellBodySx(bodyBgColor, bodyTextColor, borderColor)}>{row.monto}</TableCell>

              <TableCell sx={getCellBodySx(bodyBgColor, bodyTextColor, borderColor)}>{row.residual}</TableCell>

              {/* Acciones */}
              <TableCell
                sx={{
                  ...getCellBodySx(bodyBgColor, bodyTextColor, borderColor),
                  borderRight: "none",
                }}
                align="center"
              >
                <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0 }}>
                  <IconButton size="small" sx={{ color: iconEdit }} onClick={() => onEdit?.(index)} disabled={isLoading}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton size="small" sx={{ color: iconDelete }} onClick={() => onDelete?.(index)} disabled={isLoading}>
                    <DeleteOutlineIcon fontSize="small" />
                  </IconButton>
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
